export const STORAGE_KEYS = {
  /** App's store, dark theme, drawer value etc */
  VR_MT_GLOBAL_STORE: 'VR_MT_GLOBAL_STORE',

  VIEW_AS_TEMP_DETAILS: 'VR_MT_VIEW_AS_TEMP_DETAILS',
} as const;
